import { Store } from '@ngxs/store'
import { Injectable } from '@angular/core'
import { QuoteMetaState } from 'src/store/quote/quote.meta.state'
import { ProductTypes } from '../smart-suggestion.model'

@Injectable({ providedIn: 'root' })
export class InvertersHelper {
  constructor(private store: Store) {}

  getInvertersSuggestions() {
    const selectedPanel = this.store.selectSnapshot(
      QuoteMetaState.getSelectedPanel,
    )
    const inverters = this.store.selectSnapshot(QuoteMetaState.getInverters)
    const selectedInverters = inverters?.filter((item) => item?.quantity > 0)
    if (
      !selectedPanel ||
      !inverters ||
      inverters.length === 0 ||
      selectedInverters.length === 0
    ) {
      return []
    }
    const selectedInvertersTitles = selectedInverters.map((inverter) => {
      return `${inverter.quantity}x ${inverter.title}`
    })
    const parsedSelectedInvertersTitles = selectedInvertersTitles.join(', ')
    const suggestions = [
      {
        title: parsedSelectedInvertersTitles,
        isSelected: true,
        content: selectedInverters.map((inverter) => {
          return {
            id: inverter.id,
            type: ProductTypes.INVERTER,
            quantity: inverter.quantity,
          }
        }),
      },
    ]
    return suggestions
  }
}
